/**
 * Created by agf on 24/03/2017.
 */
contaApp.controller('FolderAdminController', ['$http', '$scope', function ($http, $scope) {
    $scope.foldersList = [];
    $http.get('/admin/1/folder_list').then(function (res) {
        $scope.foldersList = res.data;
    });
}]);
